module.exports = __webpack_public_path__ + "static/media/pick-bg.b23fe37e.png";